var exports = {
  "i": "x31de4314--7934e0--wrapper",
};

module.exports = exports;
